import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
const SectionContainer = (param)=>{
    let { title , children , leftAction  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "w-full sm:w-[600px] mx-auto bg-white sm:rounded-md sm:p-6 p-5 sm:border sm:border-gray-100",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between items-center mb-6",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        className: "text-strong",
                        children: title
                    }),
                    leftAction
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col gap-8",
                children: children
            })
        ]
    });
};
export default SectionContainer;
